import * as React from 'react';
import * as styles from './Dashboard.css';
import { connect } from 'react-redux';
import { AscendState, getDebtChartMetadata, getDebtHistory } from '../../ducks';
import Layout from '../Layout/Layout';
import LineChart from '../shared/LineChart';
import DebtList from './DebtList/DebtList';
import { Debt } from '../../models/debt';
import { getAllDebtsData, getDebtsLoading } from '../../ducks/debt';
import { getCsaUrl } from '../../ducks/onboard/onboardSelectors';
import Title from '../shared/Title/Title';
import routerHistory from '../../history';
import Grid from '@material-ui/core/Grid/Grid';
import Button from '@material-ui/core/Button/Button';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';

interface DashboardProps {
  isLoggingIn: boolean;
  isMobile: boolean;
  history: object[];
  debtMetadata: Array<{ name: string; color: string }>;
  debts: Debt[];
  loading: boolean;
  csaUrl: string;
}

const Dashboard = (props: DashboardProps) => (
  <Layout>
    <Title text="Debt Summary" />
    <div className="Dashboard">
      <DashboardBody {...props} />
    </div>
  </Layout>
);

function openCSA(csaUrl: string | null) {
  if (csaUrl) {
    window.open(csaUrl, '_blank', 'noopener,noreferrer');
  } else {
    alert('CSA URL is not available.');
  }
}

function DashboardBody({
  history,
  isLoggingIn,
  isMobile,
  debts,
  debtMetadata,
  loading,
  csaUrl,
}: DashboardProps) {
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress className={styles.loading} size={100} />
      </Grid>
    );
  } else if (isLoggingIn) {
    return <p>Redirecting you to our Login page, please wait!</p>;
  } else {
    return (
      <>
        <Grid container direction="column" justify="space-around" alignItems="center">
          <Grid item container xs={12} sm={8} justify="center">
            {debts.length > 0 && (
              <LineChart
                width="100%"
                height="100%"
                data={history}
                dataKeys={debtMetadata}
                isMobile={isMobile}
              />
            )}
          </Grid>
          <Grid item container justify="center" xs={12} sm={8}>
            <DebtList debts={debts} />
          </Grid>
          <Grid item container justify="center">
            <Button
              className={styles.addDebtButton}
              size="large"
              variant="contained"
              color="primary"
              onClick={() => openCSA(csaUrl)}>
              Download CSA
            </Button>
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: AscendState) => ({
  isLoggingIn: state.auth.isLoggingIn,
  debts: getAllDebtsData(state),
  loading: getDebtsLoading(state) || state.user.loading,
  history: getDebtHistory(state),
  debtMetadata: getDebtChartMetadata(state),
  isMobile: state.layout.isMobile,
  csaUrl: getCsaUrl(state),
});

export default connect(mapStateToProps, null)(Dashboard);
